import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Loading } from '@/components/ui/Loading';
import { useActionPlansCount } from '../hooks/useActionPlansCount';
import { Container, Divider, Section } from '../styles';
import * as S from '@/components/Settings/DataExtraction/styles';

interface SelectedReportsInfoProps {
	selectedReportType?: string;
	evaluationsCount?: number;
}

export function SelectedReportsInfo({
	selectedReportType,
	evaluationsCount
}: Readonly<SelectedReportsInfoProps>): JSX.Element | null {
	const { isLoading, actionPlansCount } = useActionPlansCount();

	if (isLoading) {
		return (
			<Col span={24}>
				<Loading size="small" />
			</Col>
		);
	}

	if (evaluationsCount === 0) return null;

	return (
		<Row gutter={[0, 32]}>
			<Col span={24}>
				<S.BodyLargeRegular>
					{I18n.get('The extraction will include action plans from the following sources:')}
				</S.BodyLargeRegular>
			</Col>
			<Col span={24}>
				<Container>
					<Section>
						<S.LabelMediumSemibold>{selectedReportType}</S.LabelMediumSemibold>
					</Section>
					<Divider />
					<Section>
						<S.LabelMediumRegular>
							{I18n.get('Evaluations')}: {evaluationsCount}
						</S.LabelMediumRegular>
					</Section>
					<Divider />
					<Section>
						<S.LabelMediumRegular>
							{I18n.get('Action plans')}: {actionPlansCount}
						</S.LabelMediumRegular>
					</Section>
				</Container>
			</Col>
		</Row>
	);
}
